import React from "react";
import { Link, useLocation } from "react-router-dom";
import { useHistory } from "react-router-dom";
import styled from "styled-components";

// components
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";

// service
import getNavigationComponent, { navIndex } from "./navigation.config";
import Constants from "../../constants";
import Devices from "../../Devices";
import CacheService from "../../service/cache.service";
import AppContext from "../../context/context";
import Actions from "../../context/actions";

const Navlink = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin: 0 16px;
  font-size: 16px;
  font-weight: ${(props) => (props.active ? "bold" : "normal")};
  opacity: ${(props) => (props.active ? 1 : 0.3)};
  color: ${(props) => (props.active ? Constants.primary_color : "inherit")};
`;

const Navtext = styled.p`
  margin: 0 4px;
`;

const NavDiv = styled.div`
  margin-left: auto;
  display: flex;
  flex-direction: row;
  align-items: center;
  //responsive
  @media ${Devices.tablet} {
    overflow-x: scroll;
  }
`;

const Navigation = ({ user, name }) => {
  const location = useLocation();
  const history = useHistory();
  const navigations = getNavigationComponent(user);
  const dispatch = React.useContext(AppContext)["dispatch"];

  // state
  const [activeTab, setActiveTab] = React.useState(1);

  const _changeActiveTab = () => {
    const path = location.pathname;
    const tabIndex = navIndex[path];
    if (tabIndex === -1) {
      CacheService.clear();
      dispatch({
        type: Actions.SET_REFRESH_CHANNEL_FLAG,
        payload: true
      });
      history.replace("/login");
    }
    setActiveTab(tabIndex);
    return;
  };

  React.useEffect(() => {
    if (user.token === null) {
      dispatch({
        type: Actions.SET_REFRESH_CHANNEL_FLAG,
        payload: true
      });
      history.replace("/login");
    }
    _changeActiveTab();
    // eslint-disable-next-line
  }, [user, location]);

  return (
    <AppBar
      position="static"
      color="transparent"
      sx={{ marginLeft: "auto", height: "58px", backgroundColor: "#ffffff" }}
      elevation={0}
    >
      <Toolbar sx={{ flexGrow: 1, height: "58px" }}>
        <Navlink active>
          <Navtext>{name}</Navtext>
        </Navlink>
        <NavDiv>
          <Navlink active>
            <Navtext>Hi, {user?.username}</Navtext>
          </Navlink>
          {navigations.map((nav) => (
            <Link key={nav.tabIndex} to={nav.path}>
              <Navlink active={activeTab === nav.tabIndex}>
                {nav.icon}
                <Navtext>{nav.name}</Navtext>
              </Navlink>
            </Link>
          ))}
        </NavDiv>
      </Toolbar>
    </AppBar>
  );
};

export default Navigation;
